import {ICommodities} from '../models/ICommodityModel';
import * as CommodityActions from '../actions/CommodityActions';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';

const initialState: Array<ICommodities> = [];
export const reducer = createReducer(
  initialState,
  on(CommodityActions.CommoditiesReceivedAction, (state, {commodities}) => [...commodities])
);

export const selectRoot = createFeatureSelector<ICommodities[]>('commodities');

export const getCommodities = createSelector(
  selectRoot,
  state => state
);
